import React, { ChangeEvent, Fragment, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { withStyles } from '@mui/styles';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import {
  deleteCustomer,
  getCountries,
  getSegments,
  getStakeholdersById,
  searchCustomers
} from 'src/services/projectService';
import { TableColumnCell } from 'src/components/TableColumnCell';
import ToggleModal from './ToggleModal';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import { useAppSelector } from 'src/hooks/hooks';
import {
  getRolePermissions
} from 'src/services/authService';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { useNavigate } from 'react-router';
import moment from 'moment';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useForm } from 'react-hook-form';

interface Filters {
  status: string | null;
}

const applyFilters = (clients: any[]): any[] => {
  return clients.filter((client) => {
    let matches = true;
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const CustomerView = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState<Filters>({
    status: null
  });

  let initialClientFilterValues = {
    status: null
  };

  const navigate = useNavigate();
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  var initalList: any[] = [];
  const [customers, setCustomers] = useState(initalList);
  const [allCustomers, setAllCustomers] = useState(initalList);
   
  const [permissions, setPermissions] = useState([]);
  const [expand, setExpand] = useState<any>();
  const [projectExpand, setProjectExpand] = useState<any>();
  const [stakeholderExpand, setStakeholderExpand] = useState<any>();
  const [toggleFilter, setToggleFilter] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleExpand = (code) => {
    setExpand(
      {
        id: code,
        expand: expand?.id === code ? !expand.expand : true
      }
    );
    setProjectExpand({id: null, projectExpand: false});
    setStakeholderExpand({id: null, stakeholderExpand: false});
  }

  const handleProjectExpand = (code, isAllClose?) => {
    setStakeholderExpand({id: null, stakeholderExpand: false});
    if(isAllClose){
      setExpand({id: null, expand: false});
    }
    setProjectExpand(
      {
        id: code,
        projectExpand: projectExpand?.id === code ? !projectExpand.projectExpand : true
      }
    );
  }

  const handleStakeholderExpand = (code, isAllClose?) => {
    setProjectExpand({id: null, projectExpand: false});
    if(isAllClose){
      setExpand({id: null, expand: false});
    }
    setStakeholderExpand(
      {
        id: code,
        stakeholderExpand: stakeholderExpand?.id === code ? !stakeholderExpand.stakeholderExpand : true
      }
    );
  }

  const [filteredCustomers, setfilteredCustomers] = useState<any>(
    applyFilters(customers)
  );

  const [paginatedCustomers, setpaginatedCustomers] = useState<any>(
    applyPagination(customers, page, limit)
  );

  const { register, handleSubmit, reset, setValue } = useForm({
    defaultValues: initialClientFilterValues
  });

  const onSubmit = (data) => {
    dispatch(AppActions.showLoader());
    setPage(0);
    setLimit(10);

    const filter = data.status === 'Active' ? true : false;
    const result = [];
    for(let i=0;allCustomers.length > i;i++){
      const customerArray = [];
      for(let j=0;allCustomers[i].customers.length > j;j++){
        const customers = allCustomers[i]?.customers;
        customers[j]?.isActive === filter && customerArray.push(customers[j]);
      }
      customerArray.length > 0 && result.push({...allCustomers[i], customers: customerArray});
    }

    if(searchKeywords.length > 0){
      const searchData = [];
      for(let i=0;result.length > i;i++){
        const filteredCus = result[i].customers.filter(el => el.name.toLowerCase().includes(searchKeywords));
        filteredCus.length > 0 && searchData.push({...result[i], customers: filteredCus});
      }
      setCustomers(searchData);
    } else{
      setCustomers(result);
    }
    dispatch(AppActions.hideLoader());
  };

  useEffect(() => {
    setfilteredCustomers(applyFilters(customers));
  }, [customers, page, limit, filter]);

  useEffect(() => {
    setpaginatedCustomers(applyPagination(customers, page, limit));
  }, [customers, filteredCustomers, page, limit]);

  const resetFilterResult = () => {
    reset();
    setFilter(initialClientFilterValues);
    getSegmentsCustomersAfterClear();
  };

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Customer');
      setPermissions(arr[0].permissions);
    });
  };

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const [openCustomers, setOpenCustomers] = useState(false);
  const [customerEdit, setCustomerEdit] = useState(false);
  const [editDataCustomer, setEditDataCustomer] = useState<any>({});
  const [segments, setSegments] = useState('');
  const [countries, setCountries] = useState([]);
  const [openConfirmationCustomerDelete, setOpenConfirmationCustomerDelete] = useState(false);
  const [customerDeleteID, setCustomerDeleteID] = useState('');

  const toggleCustomersAdd = () => {
    setOpenCustomers(!openCustomers);
  };

  const toggleConfirmationCustomerDelete = () => {
    setOpenConfirmationCustomerDelete(!openConfirmationCustomerDelete);
  };

  const deleteCustomerFunc = async () => {
    const stakeholders: any = await getStakeholdersById(customerDeleteID);
    if (stakeholders?.data?.length > 0) {
      dispatch(
        AppActions.toggleSnackBarOpen({
          message:
            'This client has assigned  stakeholders. Please remove the stakeholders before deleting this client.',
          severity: 'error'
        })
      );
      toggleConfirmationCustomerDelete();
    } else {
      dispatch(AppActions.showLoader());
      deleteCustomer(customerDeleteID)
        .then(() => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'You have deleted the client successfully.',
              severity: 'success'
            })
          );
          getSegmentsCustomers();
          toggleConfirmationCustomerDelete();
          dispatch(AppActions.hideLoader());
        })
        .catch((error) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: error?.response?.data,
              severity: 'error'
            })
          );
          dispatch(AppActions.hideLoader());
          toggleConfirmationCustomerDelete();
        });
    }
  };

  useEffect(() => {
    const isNullish = Object.values(filter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(filter).length === 0 || isNullish) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [filter]);


  const getSegmentsCustomers = () => {
    getSegments().then((res) => {
      setSegments(res.data);

      const isNullish = Object.values(filter).every((value) => {
        if (value === null) {
          return true;
        }
  
        return false;
      });

      const sorted = res?.data.sort((a, b) => {
        var dateA = moment.utc(a.createdOn || new Date()).format();
        var dateB = moment.utc(b.createdOn || new Date()).format();

        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return Date.parse(dateB) - Date.parse(dateA);
      });

      const sortedData = sorted.filter(e => e.customers.length > 0)
  
      if (Object.keys(filter).length === 0 || isNullish) {
        setCustomers(sortedData);
        setAllCustomers(sortedData);
      } else {
        const status = filter.status === 'Active' ? true : false;
        const result = [];
        for(let i=0;sortedData.length > i;i++){
          const customerArray = [];
          for(let j=0;sortedData[i].customers.length > j;j++){
            const customers = sortedData[i]?.customers;
            customers[j]?.isActive === status && customerArray.push(customers[j]);
          }
          customerArray.length > 0 && result.push({...sortedData[i], customers: customerArray});
        }
        setCustomers(result);
      }
    });
  };

  const getSegmentsCustomersAfterClear = () => {
    getSegments().then((res) => {
      const sorted = res?.data.sort((a, b) => {
        var dateA = moment.utc(a.createdOn || new Date()).format();
        var dateB = moment.utc(b.createdOn || new Date()).format();

        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return Date.parse(dateB) - Date.parse(dateA);
      });

      const sortedData = sorted.filter(e => e.customers.length > 0)

      if(searchKeywords.length > 0){
        const searchData = [];
        for(let i=0;sortedData.length > i;i++){
          const filteredCus = sortedData[i].customers.filter(el => el.name.toLowerCase().includes(searchKeywords));
          filteredCus.length > 0 && searchData.push({...sortedData[i], customers: filteredCus});
        }
        setCustomers(searchData);
      } else {
        setCustomers(sortedData);
        setAllCustomers(sortedData);
      }
    });
  };

  useEffect(() => {
    /* getCustomerData(); */
    getSegmentsCustomers();
    getCountries().then((res) => {
      const arr = res.data;
      const simplifiedArr = arr.map((con) => con?.name);
      const sortedData = simplifiedArr.sort((a, b) => a.localeCompare(b));
      setCountries(sortedData);
    });

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }

  }, []);

  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (event) => {
    setSearchKeywords(event.target.value.toLowerCase());
  };

  const searchGroupsAll = async (keyword: string) => {
    getSegments().then((res) => {
      setPage(0);
      const isNullish = Object.values(filter).every((value) => {
        if (value === null) {
          return true;
        }
  
        return false;
      });

      const sorted = res?.data.sort((a, b) => {
        var dateA = moment.utc(a.createdOn || new Date()).format();
        var dateB = moment.utc(b.createdOn || new Date()).format();

        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return Date.parse(dateB) - Date.parse(dateA);
      });

      const sortedData = sorted.filter(e => e.customers.length > 0)
      const searchData = [];
      for(let i=0;sortedData.length > i;i++){
        const filteredCus = sortedData[i].customers.filter(el => el.name.toLowerCase().includes(keyword));
        filteredCus.length > 0 && searchData.push({...sortedData[i], customers: filteredCus});
      }
  
      if (Object.keys(filter).length === 0 || isNullish) {
        setCustomers(searchData);
        setAllCustomers(searchData);
      } else {
        const status = filter.status === 'Active' ? true : false;
        const result = [];
        for(let i=0;searchData.length > i;i++){
          const customerArray = [];
          for(let j=0;searchData[i].customers.length > j;j++){
            const customers = searchData[i]?.customers;
            customers[j]?.isActive === status && customerArray.push(customers[j]);
          }
          customerArray.length > 0 && result.push({...searchData[i], customers: customerArray});
        }
        setCustomers(result);
      }
    });

    dispatch(AppActions.hideLoader());
  };

  useEffect(() => {
    if (searchKeywords.length > 0) {
      searchGroupsAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      getSegmentsCustomers();
    }
  }, [searchKeywords]);

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const appUser = useSelector((state: RootStateType) => state.appReducer.user);

  const [isCreatePermitted, setIsCreatePermitted] = useState(false);

  useEffect(() => {
    const createArr = [
      'Super User',
      'Managing director',
      'CEO, Operation ',
      'Project Manager',
      'Project Lead'
    ];
    if (appUser) {
      appUser.Roles.split(',').forEach(element => {
        if (createArr.includes(element)) {
          setIsCreatePermitted(true);
          return;
        }
      });
    }
  }, [appUser]);
  const { isLoading } = useAppSelector((state) => state.appReducer);

  return (
    <Fragment>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Clients
          </Typography>
        </Grid>
        <Grid item>
        {permissions.some((perm) =>
          perm.name === 'Edit Customer' && perm.value === true
          ) &&
          <Button
            id="btn-toggleCustomersAdd"
            onClick={() => {
              setCustomerEdit(false);
              toggleCustomersAdd();
            }}
            sx={{
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            style={{ height: '1.75rem' }}
          >
            Create New
          </Button>
        }
        </Grid>
      </Grid>
      <Card>
        <Grid
          container
          style={{
            justifyContent: 'space-between',
            paddingTop: '1rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingBottom: '1rem'
          }}
          spacing={2}
        >
          <Grid item xs={6}>
            <TextField
              id="mainSearchCustomerName"
              sx={{ width: 320, mr: 2 }}
              size="small"
              placeholder="Client Name"
              onChange={(e) => nameChange(e)}
              InputProps={{
                style: { fontSize: '12px', height: '1.75rem' },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{ color: '#d3d3d3' }}
                      style={{ fontSize: '15px' }}
                    />
                  </InputAdornment>
                )
              }}
            />
            <Button
              id="btn-toggleFilter"
              sx={{
                mt: { xs: 2, md: 0 },
                color: `${!toggleFilter && 'gray'}`
              }}
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => {
                setToggleFilter(!toggleFilter);
              }}
              style={{ height: '1.75rem', fontSize: '12px' }}
            >
              Filters
            </Button>
          </Grid>
        </Grid>
        {toggleFilter && (
          <Grid px={2} pb={2} style={{margin: 0}}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                spacing={2}
                style={{
                  paddingTop: 3,
                  paddingBottom: 2,
                  justifyContent: 'space-between'
                }}
              >
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <InputLabel
                      style={{
                        fontSize: '12px'
                      }}
                    >
                      Status
                    </InputLabel>
                    <Select
                      id="status"
                      className="select-text"
                      style={{
                        fontSize: '12px',
                        height: '2rem'
                      }}
                      sx={{ mt: 1 }}
                      fullWidth
                      size="small"
                      {...register('status')} 
                      value={filter.status || []}  
                      onChange={(event) => {
                        setFilter((prev) => ({ ...prev, status: event.target.value as string}));
                        setValue('status', event.target.value);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== 'Escape') {
                          e.stopPropagation();
                        }
                      }}
                    >
                      <MenuItem value="Active">
                        <ListItemText primary="Active" />
                      </MenuItem>
                      <MenuItem value="Inactive">
                        <ListItemText primary="Inactive" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                style={{ justifyContent: 'flex-end', marginTop: 4 }}
                xs={12}
              >
                <Button
                  id="btn-resetFilterResult"
                  sx={{ mt: { xs: 2, md: 0 }, mr: 1 }}
                  variant="outlined"
                  onClick={resetFilterResult}
                  className={isDisabled &&'clear-btn'}
                  disabled={isDisabled}
                  style={{ height: '1.75rem', fontSize: '12px' }}
                >
                  Clear
                </Button>
                <Button
                  id="btn-onSubmit"
                  sx={{ mt: { xs: 2, md: 0 } }}
                  disabled={isDisabled}
                  variant="outlined"
                  className={isDisabled &&'filter-btn'}
                  type="submit"
                  style={{ height: '1.75rem', fontSize: '12px' }}
                >
                  Filter
                </Button>
              </Grid>
            </form>
          </Grid>
        )}
        <Divider />
        <TableContainer className='client-table'>
          <Table style={{ borderCollapse: 'separate' }} size="small">
            <TableHead>
              <CustomTableRow sx={{ py: 10 }}>
                <TableHeaderCell className='tree-button' content="" smallFont/>
                <TableHeaderCell content="Segment" smallFont />
                <TableHeaderCell content="Client" smallFont />
                <TableHeaderCell content="Client Code" smallFont />
                <TableHeaderCell content="Project Name" paddingLeft='30px' smallFont />
                <TableHeaderCell content="Stakeholder Name" paddingLeft='30px' smallFont />
                <TableHeaderCell content="Industry" smallFont />
                <TableHeaderCell content="Country" smallFont />
                <TableHeaderCell content="Engagement lead" smallFont />
                <TableHeaderCell content="Description" smallFont />
                <TableHeaderCell content="Status" smallFont />
                {permissions.some(
                                (perm) =>
                                  perm.name === 'Edit Customer' && perm.value === true
                              ) && 
                              <TableHeaderCell sticky content="Actions" smallFont />                              
                              }
              </CustomTableRow>
            </TableHead>
            <TableBody>

            {permissions.some(
                                (perm) =>
                                  perm.name === 'View Customer' && perm.value === true
                              ) && 
              <>
              {paginatedCustomers &&
                paginatedCustomers?.length > 0 &&
                paginatedCustomers.map((listItem, i) => {
                  if(listItem?.customers.length > 0){
                    return (
                      <Fragment key={listItem?.code}>
                        <TableRow hover 
                        className={(expand?.id === listItem?.code && expand?.expand) ? 'segment-row segment-selected-row' : 'segment-row'}>
                          <TableColumnCell className='tree-button'>
                            {listItem?.customers?.length > 1 &&
                              <Button
                                sx={{
                                  mt: { xs: 2, md: 0 },
                                  fontSize: '11px',
                                  fontWeight: 'normal',
                                  width: '14px',
                                  height: '14px',
                                  padding: 0,
                                  minWidth: 'unset',
                                  borderRadius: '2px',
                                  cursor: 'pointer'
                                }}
                                onClick={e => handleExpand(listItem?.code)}
                                variant="contained"
                                startIcon={expand?.id === listItem?.code && expand?.expand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                              />
                            }
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.name}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.name : ''}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.code : ''}
                            </Typography>
                          </TableColumnCell>                          
                          <TableColumnCell>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                              <div className='border-0' style={{width: '30px'}}>
                                { (listItem?.customers?.length === 1 && listItem?.customers[0]?.projects.length > 1) && 
                                  <Button
                                    sx={{
                                      color: '#223354',
                                      backgroundColor: 'white',
                                      mt: { xs: 2, md: 0 },
                                      fontSize: '11px',
                                      fontWeight: 'normal',
                                      width: '14px',
                                      height: '14px',
                                      padding: 0,
                                      minWidth: 'unset',
                                      borderRadius: '2px',
                                      cursor: 'pointer'
                                    }}
                                    onClick={e => handleProjectExpand(listItem?.customers[0]?.id, true)}
                                    variant="contained"
                                    startIcon={projectExpand?.id === listItem?.customers[0]?.id && projectExpand?.projectExpand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                    <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                  />
                                }
                              </div>
                              <div className='border-0'>
                                <Typography
                                  marginBottom={0}
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {listItem?.customers?.length === 1 ? 
                                    listItem?.customers[0]?.projects?.length === 1 ? 
                                      listItem?.customers[0]?.projects[0]?.name : 
                                      listItem?.customers[0]?.projects?.length > 1 ? 'Multiple Projects' : '-' : ''}
                                </Typography>
                              </div>
                            </div>
                          </TableColumnCell>
                          <TableColumnCell>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                              <div className='border-0' style={{width: '30px'}}>
                                { (listItem?.customers?.length === 1 && listItem?.customers[0]?.stakeholders.length > 1) && 
                                  <Button
                                    sx={{
                                      color: '#223354',
                                      backgroundColor: 'white',
                                      mt: { xs: 2, md: 0 },
                                      fontSize: '11px',
                                      fontWeight: 'normal',
                                      width: '14px',
                                      height: '14px',
                                      padding: 0,
                                      minWidth: 'unset',
                                      borderRadius: '2px',
                                      cursor: 'pointer'
                                    }}
                                    onClick={e => handleStakeholderExpand(listItem?.customers[0]?.id, true)}
                                    variant="contained"
                                    startIcon={stakeholderExpand?.id === listItem?.customers[0]?.id && stakeholderExpand?.stakeholderExpand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                    <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                  />
                                }
                              </div>
                              <div className='border-0'>
                                <Typography
                                  marginBottom={0}
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {listItem?.customers?.length === 1 ? 
                                listItem?.customers[0]?.stakeholders?.length === 1 ? 
                                  listItem?.customers[0]?.stakeholders[0]?.name : 
                                  listItem?.customers[0]?.stakeholders?.length > 1 ? 'Multiple Stakeholders' : '-' : ''}
                                </Typography>
                              </div>
                            </div>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.industry ? listItem?.customers[0]?.industry : '-' : ''}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.country : ''}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.engagementLead ? listItem?.customers[0]?.engagementLead : '-' : ''}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.description ? listItem?.customers[0]?.description : '-' : ''}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell>
                            <Typography
                              paddingBottom="0.25rem"
                              paddingTop="0.5rem"
                              variant="body2"
                              style={{
                                fontSize: '11px',
                                color: `${
                                  listItem?.customers[0]?.isActive
                                    ? 'green'
                                    : 'red'
                                }`
                              }}
                              color="text.primary"
                              gutterBottom
                              noWrap
                            >
                              {listItem?.customers?.length === 1 ? listItem?.customers[0]?.isActive ? 'Active' : 'Inactive' : ''}
                            </Typography>
                          </TableColumnCell>
                          <TableColumnCell sticky>
                            {listItem?.customers?.length === 1 &&
                              <div
                                style={{
                                  background: 'white',
                                  marginLeft: 'auto'
                                }}
                              >
                              {permissions.some(
                                      (perm) =>
                                        perm.name === 'Edit Customer' && perm.value === true
                                    ) &&
                                  <div>
                                <Tooltip title="Edit" placement="top" >
                                <EditIcon
                                  id={"btn-setEditDataCustomer-" + i}
                                  onClick={() => {
                                    setCustomerEdit(true);
                                    setEditDataCustomer({...listItem?.customers[0], segmentId: listItem?.id, segmentName: listItem?.name});
                                    toggleCustomersAdd();
                                  }}
                                  style={{
                                    fontSize: '17px',
                                    cursor: 'pointer'
                                  }}
                                />
                                </Tooltip>
                                <Tooltip title="Delete" placement="top" >
                                <DeleteOutlineIcon
                                  id={"btn-setCustomerDeleteID-" + i}
                                  onClick={() => {
                                    setCustomerDeleteID(listItem?.customers[0]?.id);
                                    toggleConfirmationCustomerDelete();
                                  }}
                                  style={{
                                    fontSize: '17px',
                                    cursor: 'pointer'
                                  }}
                                />
                                </Tooltip>
                                  </div>
                            
                              }
                              </div>
                            }
                          </TableColumnCell>
                        </TableRow>
                        {
                          expand?.id === listItem?.code && expand?.expand && listItem?.customers.length > 1 && 
                          listItem?.customers.map((customer, index) => {
                            return (
                              <Fragment key={customer?.code}>
                                <TableRow
                                  hover
                                  key={customer?.code}
                                  className='customer-row'
                                >
                                  <TableColumnCell className='tree-button'></TableColumnCell>
                                  <TableColumnCell></TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      style={{ fontSize: '11px' }}
                                      variant="body2"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.name}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      style={{ fontSize: '11px' }}
                                      variant="body2"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.code}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div className='border-0' style={{width: '30px'}}>
                                        { customer?.projects?.length > 1 && 
                                          <Button
                                            sx={{
                                              color: '#223354',
                                              backgroundColor: 'white',
                                              mt: { xs: 2, md: 0 },
                                              fontSize: '11px',
                                              fontWeight: 'normal',
                                              width: '14px',
                                              height: '14px',
                                              padding: 0,
                                              minWidth: 'unset',
                                              borderRadius: '2px',
                                              cursor: 'pointer'
                                            }}
                                            onClick={e => handleProjectExpand(customer?.id)}
                                            variant="contained"
                                            startIcon={projectExpand?.id === customer?.id && projectExpand?.projectExpand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                            <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                          />
                                        }
                                      </div>
                                      <div className='border-0'>
                                        <Typography
                                          marginBottom={0}
                                          paddingBottom="0.25rem"
                                          paddingTop="0.5rem"
                                          variant="body2"
                                          style={{ fontSize: '11px' }}
                                          color="text.primary"
                                          gutterBottom
                                          noWrap
                                        >
                                          {customer?.projects?.length === 1 ? 
                                            customer?.projects[0]?.name : 
                                            customer?.projects?.length > 1 ? 'Multiple Projects' : '-'}
                                        </Typography>
                                      </div>
                                    </div>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div className='border-0' style={{width: '30px'}}>
                                        { customer?.stakeholders?.length > 1 && 
                                          <Button
                                            sx={{
                                              color: '#223354',
                                              backgroundColor: 'white',
                                              mt: { xs: 2, md: 0 },
                                              fontSize: '11px',
                                              fontWeight: 'normal',
                                              width: '14px',
                                              height: '14px',
                                              padding: 0,
                                              minWidth: 'unset',
                                              borderRadius: '2px',
                                              cursor: 'pointer'
                                            }}
                                            onClick={e => handleStakeholderExpand(customer?.id)}
                                            variant="contained"
                                            startIcon={stakeholderExpand?.id === customer?.id && stakeholderExpand?.stakeholderExpand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                            <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                          />
                                        }
                                      </div>
                                      <div className='border-0'>
                                        <Typography
                                          marginBottom={0}
                                          paddingBottom="0.25rem"
                                          paddingTop="0.5rem"
                                          variant="body2"
                                          style={{ fontSize: '11px' }}
                                          color="text.primary"
                                          gutterBottom
                                          noWrap
                                        >
                                          {customer?.stakeholders?.length === 1 ? 
                                            customer?.stakeholders[0]?.name : 
                                            customer?.stakeholders?.length > 1 ? 'Multiple Stakeholders' : '-'}
                                        </Typography>
                                      </div>
                                    </div>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      style={{ fontSize: '11px' }}
                                      variant="body2"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.industry ? customer?.industry : '-'}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      style={{ fontSize: '11px' }}
                                      variant="body2"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.country}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      style={{ fontSize: '11px' }}
                                      variant="body2"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.engagementLead ? customer?.engagementLead : '-'}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      style={{ fontSize: '11px' }}
                                      variant="body2"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.description ? customer?.description : '-'}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      variant="body2"
                                      style={{
                                        fontSize: '11px',
                                        color: `${
                                          customer?.isActive
                                            ? 'green'
                                            : 'red'
                                        }`
                                      }}
                                      color="text.primary"
                                      gutterBottom
                                      noWrap
                                    >
                                      {customer?.isActive ? 'Active' : 'Inactive'}
                                    </Typography>
                                  </TableColumnCell>
                                  <TableColumnCell sticky>
                                    <div
                                      style={{
                                        background: 'white',
                                        marginLeft: 'auto'
                                      }}
                                    >
                                    {permissions.some(
                                            (perm) =>
                                              perm.name === 'Edit Customer' && perm.value === true
                                          ) &&
                                        <div>
                                      <Tooltip title="Edit" placement="top" >
                                      <EditIcon
                                        id={"btn-setEditDataCustomer-" + i + "-" + index}
                                        onClick={() => {
                                          setCustomerEdit(true);
                                          setEditDataCustomer({...customer, segmentId: listItem?.id, segmentName: listItem?.name});
                                          toggleCustomersAdd();
                                        }}
                                        style={{
                                          fontSize: '17px',
                                          cursor: 'pointer'
                                        }}
                                      />
                                      </Tooltip>
                                      <Tooltip title="Delete" placement="top" >
                                      <DeleteOutlineIcon
                                        id={"btn-setCustomerDeleteID-" + i + "-" + index}
                                        onClick={() => {
                                          setCustomerDeleteID(customer?.id);
                                          toggleConfirmationCustomerDelete();
                                        }}
                                        style={{
                                          fontSize: '17px',
                                          cursor: 'pointer'
                                        }}
                                      />
                                      </Tooltip>
                                        </div>
                                  
                                    }
                                    </div>
                                  </TableColumnCell>
                                </TableRow>
                                { projectExpand?.id === customer?.id && projectExpand?.projectExpand && customer?.projects?.length > 1 && 
                                  customer?.projects.map((project, index) => {
                                  return (
                                      <TableRow
                                        hover
                                        key={index}
                                        className='resource-row'
                                      >
                                        <TableColumnCell className='tree-button'></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell>
                                          <Typography
                                            paddingLeft="30px"
                                            paddingBottom="0.25rem"
                                            paddingTop="0.5rem"
                                            variant="body2"
                                            style={{ fontSize: '11px' }}
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                          >
                                            {project?.name}
                                          </Typography>
                                        </TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell sticky></TableColumnCell>
                                      </TableRow>
                                    );
                                  })
                                }
                                { stakeholderExpand?.id === customer?.id && stakeholderExpand?.stakeholderExpand && customer?.stakeholders?.length > 1 && 
                                  customer?.stakeholders.map((stakeholder, index) => {
                                  return (
                                      <TableRow
                                        hover
                                        key={index}
                                        className='resource-row'
                                      >
                                        <TableColumnCell className='tree-button'></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell>
                                          <Typography
                                            paddingLeft="30px"
                                            paddingBottom="0.25rem"
                                            paddingTop="0.5rem"
                                            variant="body2"
                                            style={{ fontSize: '11px' }}
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                          >
                                            {stakeholder?.name}
                                          </Typography>
                                        </TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell sticky></TableColumnCell>
                                      </TableRow>
                                    );
                                  })
                                }
                              </Fragment>
                            );
                          })
                        }
                        { projectExpand?.id === listItem?.customers[0]?.id && projectExpand?.projectExpand && listItem?.customers[0]?.projects?.length > 1 && 
                          listItem?.customers[0]?.projects.map((project, index) => {
                          return (
                              <TableRow
                                hover
                                key={index}
                                className='resource-row'
                              >
                                <TableColumnCell className='tree-button'></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingLeft="30px"
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {project?.name}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell sticky></TableColumnCell>
                              </TableRow>
                            );
                          })
                        }
                        { stakeholderExpand?.id === listItem?.customers[0]?.id && stakeholderExpand?.stakeholderExpand && listItem?.customers[0]?.stakeholders?.length > 1 && 
                          listItem?.customers[0]?.stakeholders.map((stakeholder, index) => {
                          return (
                              <TableRow
                                hover
                                key={index}
                                className='resource-row'
                              >
                                <TableColumnCell className='tree-button'></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingLeft="30px"
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {stakeholder?.name}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell sticky></TableColumnCell>
                              </TableRow>
                            );
                          })
                        }
                      </Fragment>
                    );
                  }
                })
              }
              </>
            }
            </TableBody>
          </Table>
        </TableContainer>
        {paginatedCustomers?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={filteredCustomers?.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Card>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <ToggleModal
        open={openCustomers}
        toggle={toggleCustomersAdd}
        isEdit={customerEdit}
        getData={() => {
          /* getCustomerData(); */
          getSegmentsCustomers();
        }}
        getSegmentData={()=>{}}
        data={customerEdit ? editDataCustomer : ''}
        length={customers?.length}
        segments={segments}
        countries={countries}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
      <ConfirmationModal
        open={openConfirmationCustomerDelete}
        toggle={toggleConfirmationCustomerDelete}
        message={`Are you sure want to delete this client?`}
        onConfirm={() => deleteCustomerFunc()}
        noToggle={toggleConfirmationCustomerDelete}
        isLoading={isLoading}
      />
    </Fragment>
  );
};

export default CustomerView;
